import React from 'react';
import { SvgProps } from 'react-native-svg';

/**
 * Map keys → SVG modules. Most live under `src/assets/icons/*.svg` (basename = key).
 * A few V2 / legacy screens also use assets from `src/assets/images/svg/` (unfreeze, chevrons, stars).
 */
import AlertIcon from '../../assets/icons/alert.svg';
import ArrowBackIcon from '../../assets/icons/arrow-back.svg';
import ArrowDownIcon from '../../assets/icons/arrow-down.svg';
import ArrowForwardIcon from '../../assets/icons/arrow-forward.svg';
import dashboardIcon from '../../assets/icons/dashboard.svg';
import dashboardOutlineIcon from '../../assets/icons/dashboard-outline.svg';
import journeyIcon from '../../assets/icons/journey.svg';
import wbalance from '../../assets/icons/wbalance.svg';
import ArrowLeftIcon from '../../assets/icons/arrow-left.svg';
import ArrowRightIcon from '../../assets/icons/arrow-right.svg';
import ArrowUpIcon from '../../assets/icons/arrow-up.svg';
import BalanceIcon from '../../assets/icons/balance.svg';
import BellIcon from '../../assets/icons/bell.svg';
import CalendarIcon from '../../assets/icons/calendar.svg';
import CallIcon from '../../assets/icons/call.svg';
import CardIcon from '../../assets/icons/card.svg';
import ChatIcon from '../../assets/icons/chat.svg';
import CheckIcon from '../../assets/icons/check.svg';
import ChecksIcon from '../../assets/icons/checks.svg';
import DocIcon from '../../assets/icons/doc.svg';
import DriverIcon from '../../assets/icons/driver.svg';
import EditIcon from '../../assets/icons/edit.svg';
import EyeIcon from '../../assets/icons/eye.svg';
import FingerprintIcon from '../../assets/icons/fingerprint.svg';
import FreezeIcon from '../../assets/icons/freeze.svg';
import GainIcon from '../../assets/icons/gain.svg';
import GiftIcon from '../../assets/icons/gift.svg';
import HeartIcon from '../../assets/icons/heart.svg';
import HeartFillIcon from '../../assets/icons/heart-fill.svg';
import InstagramIcon from '../../assets/icons/instagram.svg';
import LanguageIcon from '../../assets/icons/language.svg';
import ListIcon from '../../assets/icons/list.svg';
import LockIcon from '../../assets/icons/lock.svg';
import LogoutIcon from '../../assets/icons/logout.svg';
import LossIcon from '../../assets/icons/loss.svg';
import MailIcon from '../../assets/icons/mail.svg';
import MapIcon from '../../assets/icons/map.svg';
import MealIcon from '../../assets/icons/meal.svg';
import MedkitIcon from '../../assets/icons/medkit.svg';
import MenuIcon from '../../assets/icons/menu.svg';
import MinusIcon from '../../assets/icons/minus.svg';
import NewspaperIcon from '../../assets/icons/newspaper.svg';
import NoeyeIcon from '../../assets/icons/noeye.svg';
import NomealIcon from '../../assets/icons/nomeal.svg';
import PackageIcon from '../../assets/icons/package.svg';
import PlusIcon from '../../assets/icons/plus.svg';
import ReceiptIcon from '../../assets/icons/receipt.svg';
import RefreshIcon from '../../assets/icons/refresh.svg';
import ReloadIcon from '../../assets/icons/reload.svg';
import SearchIcon from '../../assets/icons/search.svg';
import SettingsIcon from '../../assets/icons/settings.svg';
import ShareIcon from '../../assets/icons/share.svg';
import SnowIcon from '../../assets/icons/snow.svg';
import StarIcon from '../../assets/icons/star.svg';
import SunnyIcon from '../../assets/icons/sunny.svg';
import TagIcon from '../../assets/icons/tag.svg';
import TimeIcon from '../../assets/icons/time.svg';
import TrashIcon from '../../assets/icons/trash.svg';
import TrophyIcon from '../../assets/icons/trophy.svg';
import TruckIcon from '../../assets/icons/truck.svg';
import UpgradeIcon from '../../assets/icons/upgrade.svg';
import UserIcon from '../../assets/icons/user.svg';
import UsersIcon from '../../assets/icons/users.svg';
import WalletIcon from '../../assets/icons/wallet.svg';
import WhatsappIcon from '../../assets/icons/whatsapp.svg';
import XIcon from '../../assets/icons/x.svg';
import YoutubeIcon from '../../assets/icons/youtube.svg';
import WalkIcon from '../../assets/icons/walk.svg';
import FlameIcon from '../../assets/icons/flame.svg';
import WaterIcon from '../../assets/icons/water.svg';
import newsIcon from '../../assets/icons/news.svg';
import HealthQuizDecoIcon from '../../assets/icons/health-quiz-deco.svg';
import HealthAlertIcon from '../../assets/icons/health-alert.svg';
import InfoIcon from '../../assets/icons/info.svg';
import ConsultExpertDecoIcon from '../../assets/icons/consult-expert-deco.svg';
import ChevronDownIcon from '../../assets/icons/chevron-down.svg';
import EllipseOutlineIcon from '../../assets/icons/ellipse-outline.svg';
import UnfreezeIcon from '../../assets/images/svg/unfreeze.svg';
import PauseIcon from '../../assets/images/svg/pause.svg';
import ChevronLeftIcon from '../../assets/images/svg/chevron-left.svg';
import ChevronRightIcon from '../../assets/images/svg/chevron-right.svg';
import StarFullIcon from '../../assets/images/svg/star-full.svg';
import StarOutlineIcon from '../../assets/images/svg/star-outline.svg';
import ExpandIcon from '../../assets/icons/expand.svg';
import Expand2Icon from '../../assets/icons/expand2.svg';
import JourneyGoalLossIcon from '../../assets/icons/journey-goal-loss.svg';
import JourneyGoalGainIcon from '../../assets/icons/journey-goal-gain.svg';
import JourneyGoalMaintainIcon from '../../assets/icons/journey-goal-maintain.svg';
import JourneyActivitySedentaryIcon from '../../assets/icons/journey-activity-sedentary.svg';
import JourneyActivityLightIcon from '../../assets/icons/journey-activity-light.svg';
import JourneyActivityModerateIcon from '../../assets/icons/journey-activity-moderate.svg';
import JourneyActivityActiveIcon from '../../assets/icons/journey-activity-active.svg';
import JourneyActivityIntenseIcon from '../../assets/icons/journey-activity-intense.svg';
const iconMap: Record<string, React.FC<SvgProps>> = {
  alert: AlertIcon,
  'arrow-back': ArrowBackIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-forward': ArrowForwardIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  balance: BalanceIcon,
  bell: BellIcon,
  /** Alias — same asset as `bell` (inbox / push entry points use this name). */
  notifications: BellIcon,
  calendar: CalendarIcon,
  call: CallIcon,
  card: CardIcon,
  chat: ChatIcon,
  check: CheckIcon,
  checks: ChecksIcon,
  doc: DocIcon,
  driver: DriverIcon,
  edit: EditIcon,
  eye: EyeIcon,
  expand: ExpandIcon,
  expand2: Expand2Icon,
  fingerprint: FingerprintIcon,
  freeze: FreezeIcon,
  pause: PauseIcon,
  gain: GainIcon,
  gift: GiftIcon,
  heart: HeartIcon,
  'heart-fill': HeartFillIcon,
  instagram: InstagramIcon,
  language: LanguageIcon,
  list: ListIcon,
  lock: LockIcon,
  logout: LogoutIcon,
  loss: LossIcon,
  mail: MailIcon,
  map: MapIcon,
  meal: MealIcon,
  medkit: MedkitIcon,
  menu: MenuIcon,
  minus: MinusIcon,
  newspaper: NewspaperIcon,
  noeye: NoeyeIcon,
  nomeal: NomealIcon,
  package: PackageIcon,
  plus: PlusIcon,
  receipt: ReceiptIcon,
  refresh: RefreshIcon,
  reload: ReloadIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  share: ShareIcon,
  snow: SnowIcon,
  star: StarIcon,
  sunny: SunnyIcon,
  tag: TagIcon,
  time: TimeIcon,
  trash: TrashIcon,
  trophy: TrophyIcon,
  truck: TruckIcon,
  upgrade: UpgradeIcon,
  user: UserIcon,
  users: UsersIcon,
  wallet: WalletIcon,
  whatsapp: WhatsappIcon,
  x: XIcon,
  youtube: YoutubeIcon,
  walk: WalkIcon,
  flame: FlameIcon,
  water: WaterIcon,
  journey: journeyIcon,
  'journey-goal-loss': JourneyGoalLossIcon,
  'journey-goal-gain': JourneyGoalGainIcon,
  'journey-goal-maintain': JourneyGoalMaintainIcon,
  'journey-activity-sedentary': JourneyActivitySedentaryIcon,
  'journey-activity-light': JourneyActivityLightIcon,
  'journey-activity-moderate': JourneyActivityModerateIcon,
  'journey-activity-active': JourneyActivityActiveIcon,
  'journey-activity-intense': JourneyActivityIntenseIcon,
  dashboard: dashboardIcon,
  'dashboard-outline': dashboardOutlineIcon,
  wbalance: wbalance,
  news: newsIcon,
  'health-quiz-deco': HealthQuizDecoIcon,
  'health-alert': HealthAlertIcon,
  info: InfoIcon,
  'consult-expert-deco': ConsultExpertDecoIcon,
  'chevron-down': ChevronDownIcon,
  'ellipse-outline': EllipseOutlineIcon,
  unfreeze: UnfreezeIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  /** LTR “back” = left chevron; RTL month nav swaps order in the screen. */
  'chevron-back': ChevronLeftIcon,
  'chevron-forward': ChevronRightIcon,
  'star-full': StarFullIcon,
  'star-outline': StarOutlineIcon,
};

/** All valid `SvgIcon` `name` values (one per imported SVG). */
export type SvgIconName = keyof typeof iconMap;

interface SvgIconProps {
  name: string;
  size?: number;
  color?: string;
  style?: any;
}

export const SvgIcon: React.FC<SvgIconProps> = ({ name, size = 24, color = '#000000', style }) => {
  const IconComponent = iconMap[name as SvgIconName];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent width={size} height={size} color={color} style={style} />;
};

export default SvgIcon;
